
import React from 'react';
import PropTypes from 'prop-types';
import { LockOutlined, UserOutlined,LoadingOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { Input, Button, Checkbox, Row, Col, Form } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import axios from 'axios';
import ConfirmForm from '../ConfirmForm';
import {authenticate} from 'react-cognito/src/auth.js'
import ENVIRONMENT from '../../../../environments';
import Dashboard from '../../Dashboard';
import GoogleSignIn from './GoogleForm';

class NormalLoginForm extends React.Component {

  loginUser = null;
  URLParams = new URLSearchParams(window.location.search);
  redirectURL = this.URLParams.get('redirectURL');

  constructor(props) {
    super(props);
    this.state = {
      email: props.email,
      username: props.username,
      password: '',
      isLoading: false,
      login_error: '',
      stage: 1,
      codeError: ''
    };
    console.log(props);
  }

  sendVerificationCode = () => {
    this.loginUser.user.resendConfirmationCode((err) => {
      if (err) {
        this.setCodeError(err.toString());
      } else {
        console.log('Verification Code sent');
      }
    });
  }

  setCodeError = (error) => {
    this.setState({
      codeError: error
    });
  }

  onSubmit = (event) => {
    event.preventDefault();
    this.props.onSubmit(this.state.username, this.state.password);
  }

  changeUsername = (event) => {
    console.log(event.target.value)
    this.setState({ username: event.target.value });
  }

  changePassword = (event) => {
    this.setState({ password: event.target.value });
  }

  componentWillUnmount = () => {
    this.props.clearCache();
  }

  validateEmail = (email) => {
    const re = /(?:(?:\r\n)?[ \t])*(?:(?:(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*\<(?:(?:\r\n)?[ \t])*(?:@(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*(?:,@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*)*:(?:(?:\r\n)?[ \t])*)?(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*\>(?:(?:\r\n)?[ \t])*)|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*:(?:(?:\r\n)?[ \t])*(?:(?:(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*\<(?:(?:\r\n)?[ \t])*(?:@(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*(?:,@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*)*:(?:(?:\r\n)?[ \t])*)?(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*\>(?:(?:\r\n)?[ \t])*)(?:,\s*(?:(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*\<(?:(?:\r\n)?[ \t])*(?:@(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*(?:,@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*)*:(?:(?:\r\n)?[ \t])*)?(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*\>(?:(?:\r\n)?[ \t])*))*)?;\s*)/;
    return re.test(String(email).toLowerCase());
  }

  fetch_username_from_email = (email) => {
    axios.post(ENVIRONMENT.FETCH_USERNAME, { email: email })
        .then(res => {
            return res.data.username;
        })
  }
  
  confirmFromLogin = () => {
    this.setState({
      stage: 3
    });
  }

  verifyUser = (verificationCode) => {
    localStorage.clear();

    this.loginUser.user.confirmRegistration(verificationCode, true, (error) => {
      if (error) {
        console.log(error)
        this.setCodeError(error.toString());
      } else {
        this.confirmFromLogin();
      }
    });

  }

  performLoginUser = () => {
    const { store } = this.context;
    const state = store.getState();
    const userPool = state.cognito.userPool;
    const config = state.cognito.config;

    const urlParams = new URLSearchParams(window.location.search);
    const returnTo = urlParams.get('returnTo');
    if (returnTo) {
      localStorage.setItem('returnTo', returnTo);
    }

    console.log(userPool)
    console.log(config)

    authenticate(this.state.username, this.state.password, userPool, config, (e) => {
      this.loginUser = e;
      if (e.type == "COGNITO_USER_UNCONFIRMED") {
        this.sendVerificationCode();
        this.setState({
          stage: 2
        });

      } else {
        this.props.onSubmit(this.state.username, this.state.password).then(() => {
        }, () => {
          console.log('Error occured');
          this.setState({ isLoading: false });
        });
      }
      
    })
  }

  handleSubmit = e => {

    this.setState({ isLoading: true });
    if(this.validateEmail(this.state.username)){
      let email = this.state.username.toLowerCase();
      // user wants to login via email instead of username, so we'll fetch the username from the given email address
      axios.post(ENVIRONMENT.FETCH_USERNAME, { email: email })
        .then(res => {
          if(res.data.username){
            this.state.username = res.data.username;
            this.performLoginUser();
          }
          else{
            this.setState({login_error: 'User does not exist.'})
          }
        })
    }
    else{
      // we simply login via the provided username and password
      this.performLoginUser();
    }
  };

  render() {
    const formDiv = {
      'display': 'flex',
      'justifyContent': 'space-around',
      'margin-top': '40px',
    }

    const formStyle = {
      'background-color': 'white',
      'borderRadius': '5px'
    }

    return (
      <span>
        {(this.state.stage == 1)?
        <Row className='justify-on-mobile'>
          <Col span={12} className='hide-on-mobile'>
            <img className="branding-image" src={'/img/introImage.png'} alt="ALL3D Brand"/>
          </Col>
          <Col xs={22} sm={22} md={24} lg={12} className='web-desktop-width'>
            <div className="login-frm" style={formDiv}>
              <div style={formStyle}>
                <div style={formDiv}>
                  <div style={formStyle}>
                    <Form onFinish={this.handleSubmit} onFinishFailed={(e) => console.log(e) } className="login-form" initialValues={{ remember: false }}>
                      <h5 className="manrope f-16 w-700 black-00">  
                        Welcome back
                      </h5>
                      <h3 className="manrope f-24 w-700 black-00">  
                        Log into your ALL3D account
                      </h3>
                      <Form.Item
                          name="username"
                          rules={[
                            {
                              required: true,
                              message: <span className='manrope f-14 red'>Please enter your username or email</span>,
                            },{ pattern: "^[^\\s]+(\\s+[^\\s]+)*$", message: <span className='manrope f-14 red'>Spaces are not allowed, whitespace found at the end</span> }
                          ]}
                        >
                          <Input placeholder="Username or email" className='manrope f-14 w-400 placeholder black'
                            onChange={this.changeUsername}/>
                        </Form.Item>


                      <Form.Item name='password' rules={[{ required: true, message: <span className='manrope f-14 red'>Please enter your password</span> }]} >
                          <Input.Password
                            className="placeholder black custom-input-suffix manrope f-14 w-400"
                            type="password"
                            placeholder="Password"
                            onChange={this.changePassword}
                            iconRender={visible => (
                                <span
                                  style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                  }}
                                >
                                  {visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                </span>
                              )}
                          />
                      </Form.Item>
                      <Form.Item name='remember'>
                        <div className='justify-space-between'>
                          <Checkbox className='manrope f-14 w-400'>Remember me</Checkbox>
                          <Link to="/reset">
                            <a className="login-form-forgot manrope f-14 w-700 blue" href="">
                              Forgot password?
                            </a>
                          </Link>
                        </div>
                        <Button htmlType="submit" className="modal-okay square font-16 center-btn mt-16">
                          Log in {this.state.isLoading ? <LoadingOutlined spin /> : ''}
                        </Button>
                        {this.state.login_error != '' ?
                        <div className="manrope f-14 red text-center mt-10">{this.state.login_error}</div> 
                        : this.props.cognito.error ?
                        <div className="manrope f-14 red text-center mt-10">{this.props.cognito.error == 'Refresh Token has expired' ? 'Your session has timed out. Please login again.' : this.props.cognito.error}</div> : ''
                        }
                        <div className='text-center manrope f-14 w-500 black-00 mt-20'>
                          New to ALL3D?&nbsp;
                          <Link to={this.redirectURL ? `/register?redirectURL=${this.redirectURL}` : '/register'} ><a href="" className="manrope f-14 w-700 blue">Sign up</a></Link>
                        </div>
                      </Form.Item>
                    </Form>
                    <div style={{ display: "flex", alignItems: "center", margin: "20px 0" }}>
                      <hr style={{ flex: 1, border: "none", height: "1px", backgroundColor: "#ccc" }} />
                      <span style={{ margin: "0 10px 5px", color: "#666", fontSize: "14px" }}>or</span>
                      <hr style={{ flex: 1, border: "none", height: "1px", backgroundColor: "#ccc" }} />
                    </div>
                    <GoogleSignIn />
                    <div className='text-center manrope f-12 w-400 grey-66 mt-40 mb-40'>By continuing, you accept ALL3D's <a href="https://all3d.ai/terms">Terms of Use</a> and <a href="https://all3d.ai/privacy">Privacy Policy</a>.</div>
                    </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={24} lg={12} className='show-on-mobile justify-in-center'>
            <img className="branding-image login-page-mobile-img" src={'/img/introImageMobile.png'} />
          </Col>
        </Row>
        :
        <span>
        {(this.state.stage == 2)?
          <ConfirmForm
            confirmFromLogin={this.confirmFromLogin}
            verifyUser={this.verifyUser}
            codeError={this.state.codeError}
            sendVerificationCode={this.sendVerificationCode}
          ></ConfirmForm>
          :
          <Dashboard registerUsername={this.state.username} registerPassword={this.state.password}/>
        }
        </span>
        }
      </span>
    );
  }
}

const mapStateToProps = state => state;

NormalLoginForm.contextTypes = {
  store: PropTypes.object,
};

export default withRouter(connect(
  mapStateToProps
)(NormalLoginForm)
)
